export default __webpack_public_path__ + "static/media/empty_data.c1610957.svg";